"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContentForMatching = void 0;
var _react = _interopRequireDefault(require("react"));
var _map = _interopRequireDefault(require("lodash/map"));
var _parse = _interopRequireDefault(require("autosuggest-highlight/parse"));
var _MenuStyles = require("./MenuStyles");
var _helpers = require("../../helpers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var getContentForMatching = function getContentForMatching(text, query) {
  return (0, _map["default"])((0, _parse["default"])(text, (0, _helpers.matcher)(text, query)), function (_ref, index) {
    var part = _ref.text,
      highlight = _ref.highlight;
    return highlight ? /*#__PURE__*/_react["default"].createElement(_MenuStyles.Highlight, {
      key: index
    }, part) : /*#__PURE__*/_react["default"].createElement("span", {
      key: index
    }, part);
  });
};
exports.getContentForMatching = getContentForMatching;